import { render } from "./Profile.vue?vue&type=template&id=65bb07f9&scoped=true&ts=true"
import script from "./Profile.vue?vue&type=script&lang=ts"
export * from "./Profile.vue?vue&type=script&lang=ts"

import "./Profile.vue?vue&type=style&index=0&id=65bb07f9&lang=scss&scoped=true"

import exportComponent from "/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65bb07f9"]])

export default __exports__